import {NullableKeys} from '@fl/cmsch-fe-library';

import {Criterias} from './criterias';

/** Redux form name for the cow filter form. */
export const matingCowsFilterFormName = 'matingCowsFilter';

/** Form values used by the cow filter form. */
export type MatingCowsFilterFormValues = NullableKeys<{
    /** Selected breeder id. */
    breederId: number,
    /** Selected farm ids. */
    farmIds: Array<number>,
    /** Structured criteria filters. */
    criterias: Criterias,
    /** Validation hack used to retrigger redux-form validation. */
    validationHack: number,
}>;

/** Initial cow filter form values. */
export const matingCowsInitialFormValues = {
    breederId: null,
    farmIds: null,
    criterias: null,
    validationHack: null,
};
